import AutoComplete from 'Components/AutoComplete'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import React, { useEffect, useState } from 'react'
import Bool from './Components/Bool'
import ComboMulti from './Components/ComboMulti'
import ComboMultiBool from './Components/ComboMultiBool'
import ComboMultiEntier from './Components/ComboMultiEntier'
import ComboMultiUpload from './Components/ComboMultipleDocument'
import ComboMultiSaisieLibre from './Components/ComboMultiSaisieLibre'
import ComboSimple from './Components/ComboSimple'
import ComboSimpleBool from './Components/ComboSimpleBool'
import ComboSimpleUpload from './Components/ComboSimpleDocument'
import ComboSimpleEntier from './Components/ComboSimpleEntier'
import ComboSimpleSaisieLibre from './Components/ComboSimpleSaisieLibre'
import InputTextBasic from './Components/InputTextBasic'
import PaysNationaliteLangue from './Components/PaysNationaliteLangue'
import SaisieLibre from './Components/SaisieLibre'
import SaisieLibreBool from './Components/SaisieLibreBool'
import SaisieLibreUpload from './Components/SaisieLibreDocument'
import SaisieLibreMultiple from './Components/SaisieLibreMultiple'
import SaisieLibreMultipleBool from './Components/SaisieLibreMultipleBool'
import SaisieLibreMultipleUpload from './Components/SaisieLibreMultipleDocument'
import TextArea from './Components/TextArea'

export default React.memo(props => {

  const [datas, setDatas] = useState(Data.list(props.module, props.object, props.search || {}) || [])
  const [options, setOptions] = useState([])
  const [component, setComponent] = useState(null)

  const myComponent = () => {
    switch (props.type) {
      case Constants.typeSaisie.ComboSimple:
        return <ComboSimple {...props} onChange={onChange} options={options} />

      case Constants.typeSaisie.ComboMulti:
        return <ComboMulti {...props} onChange={onChange} options={options} />

      case Constants.typeSaisie.InputTextBasic:
        return <InputTextBasic {...props} onChangeInput={onChangeInput} inputType={props.inputType} />

      case Constants.typeSaisie.TextArea:
        return <TextArea {...props} onChangeInput={onChangeInput} />
      case Constants.typeSaisie.SaisieLibre:
      case Constants.typeSaisie.SaisieLibreHTML:
      case Constants.typeSaisie.SaisieLibreLink:
        return <SaisieLibre {...props} multi={props.type === Constants.typeSaisie.SaisieLibreHTML} onChangeSaisieLibre={onChangeSaisieLibre} link={props.type === Constants.typeSaisie.SaisieLibreLink} />

      case Constants.typeSaisie.SaisieLibreBool:
        return <SaisieLibreBool {...props} onChangeSaisieLibreBool={onChangeSaisieLibreBool}
          onClickBoolSaisieLibreBool={onClickBoolSaisieLibreBool} />

      case Constants.typeSaisie.SaisieLibreUpload:
        return <SaisieLibreUpload {...props} onChangeSaisieLibreBool={onChangeSaisieLibreBool}
          onChangeSaisieLibreUpload={onChangeSaisieLibreUpload} />

      case Constants.typeSaisie.SaisieLibreMultipleBool:
        return <SaisieLibreMultipleBool {...props}
          onClickSaisieLibreMultipleBool={onClickSaisieLibreMultipleBool}
          onClickBoolSaisieLibreMultipleBool={onClickBoolSaisieLibreMultipleBool}
          onChangeSaisieLibeMultipleBool={onChangeSaisieLibeMultipleBool}
          onClickRemoveSaisieLibreMultipleBool={onClickRemoveSaisieLibreMultipleBool} />
      case Constants.typeSaisie.SaisieLibreMultipleUpload:
        return <SaisieLibreMultipleUpload {...props}
          onClickSaisieLibreMultipleBool={onClickSaisieLibreMultipleBool}
          onChangeUploadSaisieLibreMultipleUpload={onChangeUploadSaisieLibreMultipleUpload}
          onChangeSaisieLibeMultipleBool={onChangeSaisieLibeMultipleBool}
          onClickRemoveSaisieLibreMultipleBool={onClickRemoveSaisieLibreMultipleBool} />
      case Constants.typeSaisie.SaisieLibreMultiple:
      case Constants.typeSaisie.SaisieLibreMultipleLink:
        return <SaisieLibreMultiple {...props}
          onChangeSaisieLibeMultipleBool={onChangeSaisieLibeMultipleBool}
          onClickSaisieLibreMultipleBool={onClickSaisieLibreMultipleBool}
          onClickRemoveSaisieLibreMultipleBool={onClickRemoveSaisieLibreMultipleBool}
          link={props.type === Constants.typeSaisie.SaisieLibreMultipleLink} />
      case Constants.typeSaisie.ComboSimpleSaisieLibre:
        return <ComboSimpleSaisieLibre {...props} onChange={onChange} options={options}
          onChangeComboSimpleSaisieLibre={onChangeComboSimpleSaisieLibre} />
      case Constants.typeSaisie.ComboSimpleBool:
        return <ComboSimpleBool {...props} onChange={onChange} options={options}
          onClickComboSimpleBool={onClickComboSimpleBool} />
      case Constants.typeSaisie.ComboSimpleEntier:
        return <ComboSimpleEntier {...props} onChange={onChange} options={options}
          onChangeInput={onChangeInputEntier} />
      case Constants.typeSaisie.ComboSimpleUpload:
        return <ComboSimpleUpload {...props} onChange={onChange} options={options}
          onChangeInput={onChangeInputUpload} />
      case Constants.typeSaisie.Bool:
        return <Bool {...props} datas={datas} onChange={onClickBool} format={props.format}
          data={props.data} />
      case Constants.typeSaisie.ComboMultiSaisieLibre:
        return <ComboMultiSaisieLibre {...props} options={options} comboMultipleOption={comboMultipleOption}
          onChange={props.onChange} />
      case Constants.typeSaisie.ComboMultiEntier:
        return <ComboMultiEntier {...props} options={options} comboMultipleOption={comboMultipleOption}
          onClickAddComboMultiEntier={onClickAddComboMultiEntier}
          onClickRemoveComboMultiEntier={onClickRemoveComboMultiEntier}
          onChangeComboMultiEntier={onChangeComboMultiEntier}
          onChangeInputComboMultiEntier={onChangeInputComboMultiEntier} />
      case Constants.typeSaisie.ComboMultiUpload:
        return <ComboMultiUpload {...props} options={options} comboMultipleOption={comboMultipleOption}
          onClickAddComboMultiEntier={onClickAddComboMultiEntier}
          onClickRemoveComboMultiEntier={onClickRemoveComboMultiEntier}
          onChangeComboMultiEntier={onChangeComboMultiEntier}
          onChangeInputComboMultiUpload={onChangeInputComboMultiUpload} />
      case Constants.typeSaisie.ComboMultiBool:
        return <ComboMultiBool {...props} options={options} comboMultipleOption={comboMultipleOption}
          onClickAddComboMultiBool={onClickAddComboMultiBool}
          onClickBoolComboMultiBool={onClickBoolComboMultiBool}
          onChangeComboMultiBool={onChangeComboMultiBool}
          onClickRemoveComboMultiBool={onClickRemoveComboMultiBool} />
      case Constants.typeSaisie.PaysNationaliteLangue:
        return <PaysNationaliteLangue {...props} onChange={onChange} />
      case Constants.typeSaisie.AutoComplete:
        return <AutoComplete {...props}
          onChange={props.onChange} options={options} />
      default:
        return <div>Inconnu</div>

    }
  }

  const isOptionNeeded = props.type === Constants.typeSaisie.ComboSimple || props.type === Constants.typeSaisie.ComboSimpleSaisieLibre
    || props.type === Constants.typeSaisie.ComboSimpleEntier || props.type === Constants.typeSaisie.ComboSimpleBool
    || props.type === Constants.typeSaisie.ComboMulti || props.type === Constants.typeSaisie.ComboMultiSaisieLibre
    || props.type === Constants.typeSaisie.ComboMultiEntier || props.type === Constants.typeSaisie.ComboMultiBool
    || props.type === Constants.typeSaisie.AutoComplete || props.type === Constants.typeSaisie.ComboMultiUpload
    || props.type === Constants.typeSaisie.ComboSimpleUpload

  const restate = _ => {
    setDatas(Data.list(props.module, props.object, props.search || {}))
  }

  useEffect(() => {
    Data.addCbRestate(props.module, props.object, restate)
    return () => Data.resetCbRestate(props.module, props.object)
  }, [])

  if (isOptionNeeded) {
    useEffect(() => {
      const o = []
      if (props.subDataOption) {
        datas.sort((a, b) =>
          ((a[props.dataMere] === undefined || a[props.dataMere] === null) && (a.id - ((b[props.dataMere] === undefined || b[props.dataMere] === null) && b.id || b[props.dataMere])))
          || (a[props.dataMere] + (a.id / Math.pow(10, a.id.toString().length)) - ((b[props.dataMere] === undefined || b[props.dataMere] === null) && b.id || (b[props.dataMere] + (b.id / Math.pow(10, b.id.toString().length)))))
        )
      }
      datas.map((data, index) => {
        if (data.condition === undefined || data.condition()) {
          o.push({
            value: props.defineData === true
              ? data.id : data[Constants.dataObject[props.module + '-' + props.object].modifSearch],
            html: props.htmlOptions && props.htmlOptions(data) ||
              (props.defineData === true
                || data[Constants.dataObject[props.module + '-' + props.object][props.columnOptions || 'libelle']] === undefined
                ?
                props.subDataOption &&
                ((data[props.dataMere] !== undefined && data[props.dataMere] !== null)
                  && <span>&nbsp;&nbsp;{data[props.columnOptions || 'libelle']}</span>
                  || <strong>{data[props.columnOptions || 'libelle']}</strong>
                )
                || data[props.columnOptions || 'libelle']
                : data[Constants.dataObject[props.module + '-' + props.object][props.columnOptions || 'libelle']]),
            label: props.defineData === true || data[Constants.dataObject[props.module + '-' + props.object][props.columnOptions || 'libelle']] === undefined
              ? props.subDataOption && (data[props.dataMere] !== undefined && data[props.dataMere] !== null) && ((datas.find(d => data[props.dataMere] === d.id) || {})[props.columnOptions || 'libelle'] + ' / ' + data[props.columnOptions || 'libelle'])
              || data[props.columnOptions || 'libelle'] : data[Constants.dataObject[props.module + '-' + props.object][props.columnOptions || 'libelle']]
          })
        }
      })
      setOptions(o)
    }, [datas])
  }

  const onChange = (data, name, event) => {
    if (props.infoTiers) {
      data = {
        ...(props.data || {}),
        id: data
      }
    }
    props.onChange(data, props.name, event)
  }

  const onChangeInputUpload = (data, link) => {
    if (props.infoTiers) {
      data = {
        ...(props.data || {}),
        valeur_entier: data || '',
        media_lien: link
      }
    }
    props.onChange(data, props.name)
  }

  const onChangeInputEntier = (data) => {
    if (props.infoTiers) {
      data = {
        ...(props.data || {}),
        valeur_entier: data || '',
      }
    }
    props.onChange(data, props.name)
  }

  const onChangeInput = (data) => {
    if (props.infoTiers) {
      data = {
        ...(props.data || {}),
        text: data || '',
      }
    }
    props.onChange(data, props.name)
  }

  const comboMultipleOption = (options, value) => {
    return options.filter(o => o.value === value || (props.data !== undefined ? props.data : []).findIndex(d => d.id === o.value) === -1)
  }

  const onChangeSaisieLibre = (data) => {
    if (props.infoTiers) {
      data = {
        ...(props.data || {}),
        text: data || [],
      }
    }
    props.onChange(data, props.name)
  }

  const onChangeSaisieLibeMultipleBool = (e, index) => {
    let data = props.data !== undefined ? EurestoClone(props.data) : { text: [] }
    data[index].text = e
    props.onChange(data, props.name)
  }

  const onChangeSaisieLibreBool = (e) => {
    let data = props.data !== undefined ? EurestoClone(props.data) : { text: [] }
    data.text = e
    props.onChange(data, props.name)
  }

  const onChangeSaisieLibreUpload = (e, link) => {
    let data = props.data !== undefined ? EurestoClone(props.data) : { text: [] }
    data.valeur_entier = e
    data.media_lien = link
    props.onChange(data, props.name)
  }

  const onClickBoolSaisieLibreBool = () => {
    let data = props.data !== undefined ? EurestoClone(props.data) : { text: [] }
    data.valeur_bool = !(data.valeur_bool === true)
    props.onChange(data, props.name)
  }

  const onClickSaisieLibreMultipleBool = () => {
    let data = props.data !== undefined ? EurestoClone(props.data) : []
    data.push({ text: [], valeur_bool: true })
    props.onChange(data, props.name)
  }

  const onClickRemoveSaisieLibreMultipleBool = (index) => {
    let data = EurestoClone(props.data)
    data.splice(index, 1)
    props.onChange(data, props.name)
  }

  const onChangeUploadSaisieLibreMultipleUpload = (index, e, link) => {
    let data = EurestoClone(props.data)
    console.log(e, link)
    data[index].valeur_entier = e
    data[index].valeur_text = link
    props.onChange(data, props.name)
  }

  const onClickBoolSaisieLibreMultipleBool = (index) => {
    let data = EurestoClone(props.data)
    data[index].valeur_bool = !(data[index].valeur_bool === true)
    props.onChange(data, props.name)
  }

  const onChangeComboSimpleSaisieLibre = (e) => {
    let data = props.data !== undefined ? EurestoClone(props.data) : { valeur_text: [] }
    data.valeur_text = e
    props.onChange(data, props.name)
  }

  const onClickBool = () => {
    let data = props.data !== undefined ? EurestoClone(props.data) : (props.infoTiers && { id: undefined } || false)
    if (props.infoTiers) {
      let boolFalse = datas.find(b => b.libelle === '0' || b.libelle === 0 || b.libelle === false).id
      let boolTrue = datas.find(b => b.libelle === '1' || b.libelle === 1 || b.libelle === true).id
      data.id = data.id === boolTrue ? boolFalse : boolTrue
    } else {
      data = data === 1 || data === '1' || data === true ? 0 : 1
    }
    props.onChange(data, props.name)
  }

  const onClickAddComboMultiEntier = () => {
    let data = props.data !== undefined ? EurestoClone(props.data) : []
    data.push({ id: undefined })
    props.onChange(data, props.name)
  }

  const onClickRemoveComboMultiEntier = (index) => {
    let data = EurestoClone(props.data)
    data.splice(index, 1)
    props.onChange(data, props.name)
  }

  const onChangeComboMultiEntier = (e, index) => {
    let data = EurestoClone(props.data)
    data[index].id = e
    props.onChange(data, props.name)
  }

  const onChangeInputComboMultiEntier = (val, index) => {
    let data = props.data
    data[index].valeur_entier = val
    props.onChange(data, props.name)
  }

  const onChangeInputComboMultiUpload = (val, index, link) => {
    let data = EurestoClone(props.data)
    data[index].valeur_entier = val
    data[index].media_lien = link
    props.onChange(data, props.name)
  }

  const onClickAddComboMultiBool = () => {
    let data = props.data !== undefined ? EurestoClone(props.data) : []
    data.push({ id: undefined, valeur_bool: true })
    props.onChange(data, props.name)
  }

  const onClickBoolComboMultiBool = (index) => {
    let data = EurestoClone(props.data)
    data[index].valeur_bool = !(data[index].valeur_bool === true)
    props.onChange(data, props.name)
  }

  const onChangeComboMultiBool = (e, index) => {
    let data = EurestoClone(props.data)
    data[index].id = e
    props.onChange(data, props.name)
  }

  const onClickRemoveComboMultiBool = (index) => {
    let data = EurestoClone(props.data)
    data.splice(index, 1)
    props.onChange(data, props.name)
  }

  const onClickComboSimpleBool = () => {
    let data = props.data !== undefined ? EurestoClone(props.data) : { id: [] }
    data.valeur_bool = !(data.valeur_bool === true)
    props.onChange(data, props.name)
  }

  useEffect(() => {
    setComponent(myComponent())
  }, [props.type, options, props.disabled, props.data])
  return component || <div />

})


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/index.js